// Toast Yapılandırması
const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 2000,
  timerProgressBar: true,
});

const centerToast = Swal.mixin({
  position: "center",
  showConfirmButton: false,
  timer: 2000,
  timerProgressBar: true,
  icon: "success",
});

function showCenterToast(message) {
  centerToast.fire({
    title: message,
  });
}

function showToast(type, message) {
  Toast.fire({
    icon: type,
    title: message,
  });
}

// document.addEventListener("DOMContentLoaded", () => {
//   //  promotie banner
//   const promoKey = "promoBannerShown";
//   const now = new Date().getTime();
//   const oneHour = 60 * 60 * 1000; // 1 saat
  
//   const stored = JSON.parse(localStorage.getItem(promoKey));
  
//   if (!stored || now - stored.timestamp > oneHour) {
//     Swal.fire({
//       imageUrl: "https://cdn.shopify.com/s/files/1/0949/4770/5173/files/WhatsApp_Image_2025-11-30_at_19.52.26.jpg?v=1764529131",
//       imageWidth: "500px",
//       imageHeight: "auto",
//       width: "auto",
//       showConfirmButton: false,
//       showCloseButton: true,
//       background: "transparent",
//       backdrop: `
//       rgba(0,0,0,0.4)
//       url("")
//       center
//       no-repeat
//     `,
//       customClass: {
//         popup: "fullsize-swal",
//         closeButton: "custom-swal-close"
//       }
//     }).then(() => {
//       localStorage.setItem(promoKey, JSON.stringify({ shown: true, timestamp: now }));
//     });
  
//     document.addEventListener("click", function closeListener(e) {
//       if (e.target.classList.contains("swal2-close")) {
//         localStorage.setItem(promoKey, JSON.stringify({ shown: true, timestamp: now }));
//         document.removeEventListener("click", closeListener);
//       }
//     });
//   }


// });
